var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome4 = function SvgHome4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.853 4.822a1.25 1.25 0 0 0-1.706 0l-5.5 5.133a1.25 1.25 0 0 0-.397.914V18c0 .69.56 1.25 1.25 1.25h11c.69 0 1.25-.56 1.25-1.25v-7.13a1.25 1.25 0 0 0-.397-.915zm-2.73-1.097a2.75 2.75 0 0 1 3.753 0l5.5 5.134a2.75 2.75 0 0 1 .874 2.01V18a2.75 2.75 0 0 1-2.75 2.75h-11A2.75 2.75 0 0 1 3.75 18v-7.13c0-.763.316-1.491.874-2.011l.511.548-.511-.548z",
    clipRule: "evenodd"
  })));
};
export default SvgHome4;